import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';
import { IServiceResponse } from 'typings/api-generic';

@Injectable({
  providedIn: 'root',
})
export class ActivityPendingRemovalService {
  constructor(private $baseApi: DoenKidsGenericApiProvider) {}

  async fetchAll(organizationUnitId: number) {
    return firstValueFrom(this.$baseApi.genericListCall('/activity/activity/pending-removal', 1000, 0, undefined, undefined, { organizationUnitId } )) as unknown as IServiceResponse;
  }

  async update(organizationUnitId: number, activityId: number, showUntil: Date) {
    return firstValueFrom(this.$baseApi.genericPutCall(`/activity/activity/pending-removal/${organizationUnitId}/activity/${activityId}`,
      {
        showUntil: showUntil.toISOString(),
      },
    )) as unknown as IServiceResponse;
  }

  async remove(organizationUnitId: number, activityId: number) {
    // eslint-disable-next-line max-len
    return firstValueFrom(this.$baseApi.genericDeleteCall(`/activity/activity/pending-removal/${organizationUnitId}/activity/${activityId}`)) as unknown as IServiceResponse;
  }
}
